import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Modal, Container } from "react-bootstrap";
import { Formik } from "formik";
import axios from "axios";
import PreviewPPozdrav from "./PreviewPPozdrav";
import PreviewSmPP from "./PreviewSmPP";
import PreviewMdPP from "./PreviewMdPP";
import { Carousel } from "react-responsive-carousel";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const RedirectForm = () => {
  const [postData, setPostData] = useState("");
  const postId = parseInt(localStorage.getItem("postId"));
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [images, setImages] = useState([]);

  const getPost = async () => {
    try {
      const response = await axios.get(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${postId}`
      );

      setImages(response.data.images);
      console.log(images);
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const handleShowPreviewModal = () => {
    setShowPreviewModal(true);
  };

  const handleClosePreviewModal = () => {
    setShowPreviewModal(false);
  };

  const handleSubmit = async (values, { resetForm }) => {
    let formData = new FormData();
    formData.append("name", postData.name);
    formData.append("text_top", values.top_text);
    formData.append("main_text", values.main_text);
    formData.append("icon", values.icon);
    formData.append("images", images.reduce((p, c) => p + c).split(","));
    formData.append("type", "poslednji_pozdrav");
    formData.append("text_bottom", values.bottom_text);
    formData.append("size", values.size);
    formData.append("parent", postId);

    try {
      const response = await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/?parent=${postId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      // Display success notification
      NotificationManager.success("Poslednji pozdrav uspješno predat!");
      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
      // Reset form values
      resetForm(); // Call resetForm function
    } catch (error) {
      console.error(error);
      // Display error notification
      NotificationManager.error(
        "Greška prilikom predavanja poslednjeg pozdrava!"
      );
    }
  };
  useEffect(() => {
    const postId = localStorage.getItem("postId");
    fetchPosts(postId);
    getPost(postId);
  }, []);

  const fetchPosts = async (postId) => {
    try {
      const response = await axios.get(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${postId}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setPostData(response.data);
      console.log(postData);
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  return (
    <Formik
      initialValues={{
        name: postData.name,
        top_text: "",
        main_text: "",
        icon: "",
        image: "https://radojicictijanaa.pythonanywhere.com/" + postData.image,
        type: "poslednji_pozdrav",
        size: "",
        bottom_text: "",
      }}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit, setFieldValue, values, handleChange }) => (
        <Form
          className="FormaZaPopunjavanje-form"
          onSubmit={handleSubmit}
          style={{
            margin: "0 auto",
            marginTop: "3%",
            maxWidth: "500px",
            padding: "20px",
            backgroundColor: "#f5f5f5",
            borderRadius: "5px",
          }}
        >
          <div>
            <Row className="mb-3">
              <Row>
                <Col>
                  {images.length !== 0 && (
                    <Carousel
                      className="form-slider"
                      showArrows={false}
                      infiniteLoop={true}
                      autoPlay={true}
                      interval={3000}
                    >
                      {images
                        .reduce((p, c) => p + c)
                        .split(",")
                        .map((imagePath, index) => (
                          <div key={index}>
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                                border: "3px solid black",
                              }}
                              src={
                                "https://radojicictijanaa.pythonanywhere.com/" +
                                imagePath
                              }
                              alt={`Image ${index + 1}`}
                            />
                          </div>
                        ))}
                    </Carousel>
                  )}
                </Col>
                <Col>
                  <h5 className="mb-0">{postData.name}</h5>
                  <p className="mb-0">Tip: Poslednji pozdrav</p>
                </Col>
              </Row>
            </Row>
            <hr className="my-4" />
            <Row>
              <Col sm={6}>
                <Form.Group controlId="formTopText">
                  <Form.Label className="FormaZaPopunjavanje-label">
                    Gornji tekst
                  </Form.Label>
                  <Form.Control
                    name="top_text"
                    onChange={handleChange}
                    value={values.top_text}
                    className="FormaZaPopunjavanje-input"
                    placeholder="Unesite gornji tekst..."
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="formMainText" className="mt-3">
              <Form.Label className="FormaZaPopunjavanje-label">
                Glavni tekst
              </Form.Label>
              <Form.Control
                name="main_text"
                as="textarea"
                rows={4}
                onChange={handleChange}
                value={values.main_text}
                className="FormaZaPopunjavanje-textarea"
                placeholder="Unesite glavni tekst..."
              />
            </Form.Group>
            <Form.Group controlId="formBottomText" className="mt-3">
              <Form.Label className="FormaZaPopunjavanje-label">
                Ožalošćeni
              </Form.Label>
              <Form.Control
                name="bottom_text"
                as="textarea"
                rows={4}
                onChange={handleChange}
                value={values.bottom_text}
                className="FormaZaPopunjavanje-textarea"
                placeholder="Navedite ožalošćene..."
              />
            </Form.Group>

            <Form.Group controlId="formVelicina" className="mt-3">
              <Form.Label className="FormaZaPopunjavanje-label">
                Veličina
              </Form.Label>
              <Form.Check
                name="size"
                type="radio"
                label="Mala"
                value="1"
                onChange={(event) => {
                  setFieldValue("size", event.target.value);
                }}
                checked={values.size === "1"}
                className="FormaZaPopunjavanje-checkbox-label"
              />
              <Form.Check
                name="size"
                type="radio"
                label="Srednja"
                value="2"
                onChange={(event) => {
                  setFieldValue("size", event.target.value);
                }}
                checked={values.size === "2"}
                className="FormaZaPopunjavanje-checkbox-label"
              />
              <Form.Check
                name="size"
                type="radio"
                label="Velika"
                value="3"
                onChange={(event) => {
                  setFieldValue("size", event.target.value);
                }}
                checked={values.size === "3"}
                className="FormaZaPopunjavanje-checkbox-label"
              />
              <p className="mt-2 text-secondary">
                Izaberite veličinu kako biste pogledali primjer
              </p>
            </Form.Group>

            <Button
              className="FormaZaPopunjavanje-submit mt-4"
              variant="primary"
              type="submit"
            >
              Submit
            </Button>
            <Button
              variant="primary"
              className="mt-4"
              style={{ float: "right" }}
              onClick={handleShowPreviewModal}
              disabled={values.size === ""} // Disable the button if the size is not "Velika"
            >
              Pogledaj
            </Button>
          </div>
          {values.size === "3" && (
            <Modal
              show={showPreviewModal} // Use showPreviewModal instead of handleShowPreviewModal
              onHide={handleClosePreviewModal} // Use onHide instead of hide
              contentlabel="Post Modal"
              size="xl"
              style={{ padding: "0px" }}
            >
              <Container className="px-3">
                <PreviewPPozdrav />

                <Button
                  variant="secondary"
                  className="mt-4 float-right"
                  onClick={handleClosePreviewModal} // Call handleClosePreviewModal on button click
                >
                  Zatvori
                </Button>
              </Container>
            </Modal>
          )}
          {values.size === "2" && (
            <Modal
              show={showPreviewModal} // Use showPreviewModal instead of handleShowPreviewModal
              onHide={handleClosePreviewModal} // Use onHide instead of hide
              contentlabel="Post Modal"
              size="md"
              style={{ padding: "0px" }}
            >
              <Container className="px-3">
                <PreviewMdPP />

                <Button
                  variant="secondary"
                  className="mt-4 float-right"
                  onClick={handleClosePreviewModal} // Call handleClosePreviewModal on button click
                >
                  Zatvori
                </Button>
              </Container>
            </Modal>
          )}
          {values.size === "1" && (
            <Modal
              show={showPreviewModal} // Use showPreviewModal instead of handleShowPreviewModal
              onHide={handleClosePreviewModal} // Use onHide instead of hide
              contentlabel="Post Modal"
              size="md"
              style={{ padding: "0px" }}
            >
              <Container className="px-3">
                <PreviewSmPP />

                <Button
                  variant="secondary"
                  className="mt-4 float-right"
                  onClick={handleClosePreviewModal} // Call handleClosePreviewModal on button click
                >
                  Zatvori
                </Button>
              </Container>
            </Modal>
          )}
          <NotificationContainer />
        </Form>
      )}
    </Formik>
  );
};

export default RedirectForm;
